import React, { useContext } from "react";
import { Link, useHistory } from 'react-router-dom'
import { authContext } from "../../store/AuthContext";

import PrimaryButton from "../Buttons/PrimaryButton";


const Header = () => {

    const authCtx = useContext(authContext);
    const history = useHistory();


    const logoutHandler = () => {
        authCtx.logout();
        history.push('/')
    }

    return (
        <div className="header">
            <div className='container d-flex align-items-center justify-content-between' >
                <Link to='/'>
                    <img className='header-logo' src='/nk-logo.jpg' alt='nk logo' />
                </Link>
                <span className='header-name' >{`Welcome! ${authCtx.adminType.toUpperCase()} Admin`}</span>
                <PrimaryButton onClick={logoutHandler} type='button' >
                    <i className="fa fa-lock"></i> &nbsp; Logout
                </PrimaryButton>
            </div>
        </div>
    )

}

export default Header